import React, { useCallback, useEffect } from "react"
import clsx from "clsx"
import routes from "routes"
import { SearchType } from "src/components/hooks/useCreatorSearch"
import Link from "next/link"
import { useRouter } from "next/router"

type Props = {
  searchType: string
  setSearchType: (type: SearchType) => void
  updateSearchText: (text: string) => void
  showGenre?: boolean
  showCharacter?: boolean
  isRequired?: boolean
  disableCharacter?: boolean
  searchText?: string
}

const Search: React.FC<Props> = ({
  searchType,
  setSearchType,
  updateSearchText,
  searchText = "",
  showGenre = true,
  showCharacter = true,
  disableCharacter = false,
}) => {
  const router = useRouter()

  const handleClickTab = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault()
      router.push({
        pathname: router.pathname,
        query: { type: e.currentTarget.hash.substr(1) },
      })
    },
    [router],
  )

  useEffect(() => {
    if (router && router.query && router.query.type) {
      if (router.query.type === "illustrations") {
        setSearchType("illustrations")
      } else {
        setSearchType("novels")
      }
    }
  }, [router, setSearchType])

  return (
    <>
      <ul className="p-searchNav">
        <li className="p-searchNav-item">
          <a
            className={clsx({
              "p-searchNav-anchor": true,
              "is-active": searchType === "novels",
            })}
            href="#novels"
            onClick={handleClickTab}
          >
            小説を探す
          </a>
        </li>
        <li className="p-searchNav-item">
          <a
            className={clsx({
              "p-searchNav-anchor": true,
              "is-active": searchType === "illustrations",
              disabled: disableCharacter,
            })}
            href="#illustrations"
            onClick={handleClickTab}
          >
            イラストを探す
          </a>
        </li>
      </ul>
      <div className="p-searchForm">
        <div className="p-searchForm-inner">
          <div className="p-searchForm-freeword">
            <span className="p-searchForm-textfield c-search-textfield">
              <input
                className="c-textfield-primary"
                type="text"
                placeholder="フリーワード検索"
                value={searchText}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateSearchText(e.target.value)
                }}
              />
            </span>
          </div>
          <ul className="p-searchForm-nav">
            {showGenre && (
              <li className="p-searchForm-nav-item">
                <a
                  className="p-searchForm-nav-anchor"
                  href={routes.creatorSearchGenres(searchType)}
                >
                  ジャンルで検索
                </a>
              </li>
            )}
            {showCharacter && (
              <li className="p-searchForm-nav-item">
                <Link href={routes.creatorSearchCharacters()}>
                  <a className="p-searchForm-nav-anchor">キャラクターで検索</a>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </>
  )
}

export default Search
